import axios from "axios";
import { useEffect, useRef, useState } from "react"
import { useDispatch, useSelector } from "react-redux";
import { useHistory, useParams } from "react-router";
import { setCurrentPost } from "../../redux/action";
import ThumbUpAltOutlinedIcon from '@material-ui/icons/ThumbUpAltOutlined';
import ThumbUpIcon from '@material-ui/icons/ThumbUp';
import ShareIcon from '@material-ui/icons/Share';
import styles from "./profile.module.css";
import { CommentComp } from "../Comment/CommentComp";
import BlogNav from "../Blogpage/BlogNav/BlogNav";
import Blogmain from "../Blogpage/Blogmain/Blogmain";
import Blogright from "../Blogpage/Blogright/Blogright";
// import Blogmain1 from "../Blogpage/Blogmain/Blogmain";
import Twitter from "@material-ui/icons/Twitter";
import Facebook from "@material-ui/icons/Facebook";
import GitHub from "@material-ui/icons/GitHub";
// import Bookmark from "@material-ui/icons/Bookmark";
import BookmarkBorderOutlined from "@material-ui/icons/BookmarkBorderOutlined";
// import BlogFooter from "../Blogpage/BlogFooter/BlogFooter";
import { v4 as uuid } from 'uuid';



export const TempPost = () => {
    const [showCommentSection, setShowCommentSection] = useState(false);
    const loggedInUser = useSelector(state => state.loggedInUser);
    const loggedIn = useSelector(state => state.loggedIn);
    const [liked, setLiked] = useState(false);
    const [comments, setComments] = useState([]);
    const commentRef = useRef();
    const likeRef = useRef(false);
    const history = useHistory();
    const dispatch = useDispatch();
    const { id } = useParams();
    const [post, setPost] = useState({});
    const url = process.env.REACT_APP_url;

    useEffect(() => {
        // console.log(id);
        axios.get(`${url}/posts/id/${id}`)
            .then((res) => {
                // console.log(res.data.post)
                dispatch(setCurrentPost(res.data.post));
                setPost(res.data.post);
            })
            .catch((err) => {
                alert(err);
            })
        axios.get(`${url}/likes/liked/post/${id}/author/${loggedInUser._id}`)
            .then((res) => {
                // console.log(res.data.liked);
                likeRef.current = res.data.liked;
                setLiked(likeRef.current);
            })
            .catch((err) => {
                alert("gyi",err);
            })
        window.scrollTo(0, 0);
    }, []);
    const handleLiked = () => {
        if (!loggedIn) {
            history.push("/login");
            return;
        }
        likeRef.current = !likeRef.current;
        // console.log(likeRef);
        const config = {
            post: id,
            author: loggedInUser._id
        }
        if (likeRef.current) {
            axios.post(`${url}/likes/post`, config)
                .then((res) => {
                    // console.log(res.data.like);
                })
                .catch((err) => {
                    alert(err);
                })
        } else {
            axios.delete(`${url}/likes/post/${id}/author/${loggedInUser._id}`)
                .then((res) => {
                    // console.log(res.data.like);
                })
                .catch((err) => {
                    alert(err);
                })
        }
        setLiked(likeRef.current);
    }
    const handleSubmitComment = () => {
        setShowCommentSection(false);
        if (!loggedIn) {
            history.push("/login");
            return;
        }
        const config = {
            body: commentRef.current.value,
            post: post._id,
            author: loggedInUser._id
        }
        // console.log(config);
        axios.post(`${url}/comments`, config)
            .then((res) => {
                // console.log(res.data.comment);
                getComments();
            })
            .catch((err) => {
                alert(err);
            })
    }
    useEffect(() => {
        getComments();
    }, []);
    const getComments = () => {
        axios.get(`${url}/comments/post/${id}`)
            .then((res) => {
                // console.log(res.data.comments);
                setComments(res.data.comments);
                // console.log(comments);
            })
            .catch((err) => {
                alert(err);
            })
    }
    return (
        <div style={{position:"relative"}}>
            <BlogNav name={post?.author?.name} />
            <div style={{display:"flex", justifyContent:"space-around"}}>
            <div className={styles.content}>
                <div className={styles.blogImageDiv}>
                    <img src={post.image} alt="blog"/>
                </div>
                <h1 className={styles.blogHeading}>{post?.title}</h1>
                <Blogmain post={post} />
            <div className={styles.blogBody}>
                {post.body}
                    </div>
<div className={styles.addComment}>
            <div className={styles.likeBtn} style={{margin:"39px 0px"}}>
                            {liked ? <ThumbUpIcon fontSize="large" onClick={handleLiked} className={styles.liked} /> : <ThumbUpAltOutlinedIcon style={{color:"#383636"}} fontSize="large" onClick={handleLiked} className={styles.notLiked} />}
                            <Twitter fontSize="large" style={{color:"#383636"}} />
                            <Facebook fontSize="large" style={{color:"#383636"}} />
                            <GitHub fontSize="large" style={{ color: "#383636" }} />
                            <ShareIcon fontSize="large" style={{ color: "#383636" }}/>
                            <BookmarkBorderOutlined fontSize="large" style={{color:"#383636"}}/>
                        </div>
                        </div>
                    <div className={styles.addComment}>
                        <div style={{display:"flex", justifyContent:"space-between"}}>
                        <p style={{fontSize:"19px"}}>Comments({post.comments})</p>
                            <button className={styles.btnSpl} style={{height:"55px", width:"180px"}} onClick={() => setShowCommentSection(!showCommentSection)}>Add Comment</button>
                            </div>
                        {showCommentSection ? <div><textarea row={10} className={styles.commentInpBox} ref={commentRef} placeholder="Start typing..."></textarea>
                            <button className={styles.btn} onClick={handleSubmitComment}>Submit</button></div> : null}
                    </div>
                    
            <div className={styles.commentDiv}>
                {comments.map((item) => (
                    <CommentComp key={uuid()} item={item}/>
                    // <div className={styles.eachComment}>
                    //     <div>
                    //         <img src={`/profile_pics/${item.author.profile_pic}`} alt="profile"/>
                    //         <h3>{item.author.name}</h3>
                    //         <div style={{marginLeft:"280px"}}>date</div>
                    //     </div>
                        
                    //     <p>{item.body}</p>
                    // </div>
                ))}
            </div>
            </div>
                <Blogright />
            </div>
            {/* <BlogFooter/> */}
        </div>
    )
}